import React, { useState } from "react";
import { Box, Paper, Tabs, Tab, Typography } from "@mui/material";
import InvoiceProduct from "./InvoiceProduct";
import InvoicePayments from "./InvoicePayments";
import InvoiceRetention from "./InvoiceRetention";
import InvoiceAccount from "./InvoiceAccount";

const InvoiceDetail = ({ doc, documentoId }) => {
  const [tabValue, setTabValue] = useState(0);

  const isCompra = String(doc?.origen || "").toUpperCase() === "COMPRA";
  const hasAccounts = isCompra && Array.isArray(doc?.gastos) && doc.gastos.length > 0;

  const tabs = [
    { label: "Productos", key: "productos" },
    ...(hasAccounts ? [{ label: "Cuentas", key: "cuentas" }] : []),
    { label: "Retenciones", key: "retenciones" },
    { label: "Formas de Pagos", key: "pagos" },
  ];

  const handleTabChange = (_e, newValue) => {
    setTabValue(newValue);
  };

  if (!doc) {
    return (
      <Box sx={{ mx: "auto", mt: 3 }}>
        <Paper sx={{ p: 3, borderRadius: 2 }}>
          <Typography sx={{ fontWeight: 700 }}>Cargando detalle…</Typography>
        </Paper>
      </Box>
    );
  }

  const currentTab = tabs[tabValue]?.key || "productos";

  return (
    <Box sx={{ mx: "auto", mt: 3 }}>
      <Paper
        sx={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        }}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons={false}
          sx={{
            backgroundColor: "#1565C0",
            "& .MuiTab-root": {
              color: "#fff",
              textTransform: "none",
              fontWeight: 600,
              minHeight: "48px",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              transition: "all 0.2s ease",
            },
            "& .Mui-selected": {
              backgroundColor: "#fff",
              color: "#1565C0",
              borderTop: "4px solid #1565C0",
              borderLeft: "4px solid #1565C0",
              borderRight: "4px solid #1565C0",
              borderBottom: "none",
              marginTop: "5px",
              marginLeft: "10px",
            },
            "& .MuiTabs-indicator": { display: "none" },
          }}
        >
          {tabs.map((tab) => (
            <Tab key={tab.key} label={tab.label} />
          ))}
        </Tabs>

        <Box sx={{ p: 3 }}>
          {currentTab === "productos" && <InvoiceProduct doc={doc} />}
          {currentTab === "cuentas" && <InvoiceAccount doc={doc} />}
          {currentTab === "retenciones" && (
            <InvoiceRetention doc={doc} documentoId={documentoId} />
          )}
          {currentTab === "pagos" && <InvoicePayments doc={doc} />}
        </Box>
      </Paper>
    </Box>
  );
};

export default InvoiceDetail;